import { TextField } from '@mui/material';
import { ContactFields } from '../../components/ContactFields';
import { FormDialog, FullRow } from '../../components/FormDialog';
import { ServiceCheckboxes } from '../../components/ServiceCheckboxes';
import { FormField } from '../../components/FormField';
import type { Service } from '../../lib/services';
import { slug } from '../../lib/text';
import { addedText } from '../claudeTasks/useVaultRecords';
import { useAddForm } from '../../lib/useAddForm';
import { CARRIER_MODES, type Carrier } from './sample';

const blank = {
  name: '',
  country: '',
  city: '',
  contact: '',
  phone: '',
  email: '',
  mode: 'Sea',
  coverage: '',
  notes: '',
  services: [] as Service[],
};

/** A form for a new shipping line or airline. It is kept in the browser for now; the vault holds the real list. */
export function AddCarrierDialog({
  open,
  onClose,
  onAdd,
}: {
  open: boolean;
  onClose: () => void;
  onAdd: (c: Carrier) => void | Promise<unknown>;
}) {
  const { form, set, save, busy } = useAddForm(
    blank,
    (f): Carrier => ({
      ...f,
      mode: f.mode as Carrier['mode'],
      id: slug(f.name),
      address: '',
      website: '',
      cargoTypes: [],
      aliases: [f.name],
      notes: '',
      responseTime: '',
      status: 'Active',
      addedDaysAgo: 0,
    }),
    onAdd,
    onClose,
    addedText('Carrier'),
  );
  return (
    <FormDialog
      open={open}
      onClose={onClose}
      title="Add a carrier"
      saveLabel="Add carrier"
      canSave={Boolean(form.name.trim()) && !busy}
      onSave={save}
    >
      <ContactFields value={form} onChange={set} />
      <FormField label="Mode" value={form.mode} onChange={(mode) => set({ mode })} options={CARRIER_MODES} />
      <TextField
        label="Coverage / main routes"
        value={form.coverage}
        onChange={(e) => set({ coverage: e.target.value })}
      />
      <ServiceCheckboxes value={form.services} onChange={(services) => set({ services })} />
      <FullRow>
        <TextField label="Notes (optional)" value={form.notes} onChange={(e) => set({ notes: e.target.value })} />
      </FullRow>
    </FormDialog>
  );
}
